import { useAtom } from "jotai";
import React, { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Popup from "reactjs-popup";
import { isOnlineAtom } from "../../../../new_appointment/appoinment/atom/AppointmentAtoms";
// import { Popup } from "semantic-ui-react";

const SidebartemSmall = ({
  name,
  activeIcon,
  inactiveIcon,
  className,
  onClick,
  route,
  type = "sidebar",
  activeClass,
  expanded,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const location = useLocation();
  const divRef = useRef();
  const [isOnline] = useAtom(isOnlineAtom);
  const handleMouseEnter = (e) => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);

    setTimeout(() => {
      setIsHovered(false);
    }, 100);
  };

  // //("route----------", name);

  useEffect(() => {
    setIsHovered(false);
    // return () => clearTimeout(handleMouseLeave);
  }, [divRef]);

  const pathSearchCases = location.pathname + location.search;

  return type === "sidebar" ? (
    !expanded ? (
      <Popup
        trigger={
          <div
            ref={divRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className={`relative ${className} ${
              pathSearchCases?.includes(route) ? "sidebar-link-active" : ""
            }`}
            onClick={onClick}
          >
            <div>
              <span>
                {pathSearchCases?.includes(route) ? activeIcon : inactiveIcon}
              </span>
            </div>
            {name === "Appointment" && (
              <div
                className={` ${
                  isOnline ? "bg-green-500" : "bg-yellow-500"
                } w-3 h-3 rounded-full absolute -top-1 -right-1`}
              ></div>
            )}
          </div>
        }
        position="right center"
        on="hover"
        closeOnDocumentClick
        arrow={true}
        contentStyle={{
          padding: "10px 15px",
          border: "none",
          width: "fit-content",
          backgroundColor: "black",
          color: "white",
        }}
        arrowStyle={{ color: "black" }}
      >
        <div className="text-sm">{name}</div>
      </Popup>
    ) : (
      <div
        ref={divRef}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        // onMouseMove={(e) => handleMouseLeave(e)}
        className={`${className} ${
          pathSearchCases?.includes(route) ? "sidebar-link-active" : ""
        }`}
        onClick={onClick}
      >
        <div>
          <span className={`${isHovered && ""}`}>
            {pathSearchCases?.includes(route) ? activeIcon : inactiveIcon}
          </span>
        </div>
      </div>
    )
  ) : (
    <div
      onClick={onClick}
      className={`${className} ${
        location.pathname === route && activeClass ? activeClass : ""
      }`}
    >
      <img
        src={`${
          location.pathname === route ? `${activeIcon}` : `${inactiveIcon}`
        }`}
      />
    </div>
  );
};

export default SidebartemSmall;
